import { render, staticRenderFns } from "./VBarChartCard.vue?vue&type=template&id=3f6fefe3&scoped=true"
import script from "./VBarChartCard.vue?vue&type=script&lang=js"
export * from "./VBarChartCard.vue?vue&type=script&lang=js"
import style0 from "./VBarChartCard.vue?vue&type=style&index=0&id=3f6fefe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fefe3",
  null
  
)

export default component.exports